/**
 *   Generated file. Do not edit
 */
import { TapResponse } from '@iotize/tap';
import { SERVICE_CALLS } from './service-calls';

import { ScramLoginParams } from './models';
import { ScramLoginResponseBody } from './models';
import { EncryptedIVRequest } from './models';
import { EncryptedIVResponse } from './models';
import { AbstractService, ServiceCallType } from '@iotize/tap';

export class ScramService extends AbstractService {
  public resources = SERVICE_CALLS;

  /**
   * Initiate scram login process
   *
   * LWM2M path: /1024//40
   *
   * @tapVersion(">=1.0")
   * @param params input
   * @return
   */
  login(
    /*
     *
     */
    params: ScramLoginParams,
  ): Promise<TapResponse<ScramLoginResponseBody>> {
    return this.serviceCallRunner.execute(this.loginCall(params));
  }

  /**
   *
   *
   * LWM2M path: /1024//40
   *
   * @tapVersion(">=1.0")
   * @param params input
   * @return call options
   */
  loginCall(
    /*
     *
     */
    params: ScramLoginParams,
  ): ServiceCallType {
    const callOptions = { ...this.resources.login };

    callOptions.body = params;

    return callOptions;
  }

  /**
   * Scram login proof
   *
   * LWM2M path: /1024//41
   *
   * @tapVersion(">=1.0")
   * @param params input
   * @return
   */
  loginProof(
    /*
     *
     */
    params: Uint8Array,
  ): Promise<TapResponse<Uint8Array>> {
    return this.serviceCallRunner.execute(this.loginProofCall(params));
  }

  /**
   *
   *
   * LWM2M path: /1024//41
   *
   * @tapVersion(">=1.0")
   * @param params input
   * @return call options
   */
  loginProofCall(
    /*
     *
     */
    params: Uint8Array,
  ): ServiceCallType {
    const callOptions = { ...this.resources.loginProof };

    callOptions.body = params;

    return callOptions;
  }

  /**
   * Get scram hash iteration counter
   *
   * LWM2M path: /1024//42
   *
   * @tapVersion(">=1.11")
   * @return
   */
  getHashIteration(): Promise<TapResponse<number>> {
    return this.serviceCallRunner.execute(this.getHashIterationCall());
  }

  /**
   *
   *
   * LWM2M path: /1024//42
   *
   * @tapVersion(">=1.11")
   * @return call options
   */
  getHashIterationCall(): ServiceCallType {
    const callOptions = { ...this.resources.getHashIteration };

    return callOptions;
  }

  /**
   * Set scram hash iteration counter
   *
   * LWM2M path: /1024//42
   *
   * @tapVersion(">=1.11")
   * @param data input
   * @return
   */
  putHashIteration(
    /*
     *
     */
    data: number,
  ): Promise<TapResponse<void>> {
    return this.serviceCallRunner.execute(this.putHashIterationCall(data));
  }

  /**
   *
   *
   * LWM2M path: /1024//42
   *
   * @tapVersion(">=1.11")
   * @param data input
   * @return call options
   */
  putHashIterationCall(
    /*
     *
     */
    data: number,
  ): ServiceCallType {
    const callOptions = { ...this.resources.putHashIteration };

    callOptions.body = data;

    return callOptions;
  }

  /**
   * Start encrypted communication
   *
   * LWM2M path: /1024//47
   *
   * @tapVersion(">=1.11")
   * @return
   */
  initialize(): Promise<TapResponse<Uint8Array>> {
    return this.serviceCallRunner.execute(this.initializeCall());
  }

  /**
   *
   *
   * LWM2M path: /1024//47
   *
   * @tapVersion(">=1.11")
   * @return call options
   */
  initializeCall(): ServiceCallType {
    const callOptions = { ...this.resources.initialize };

    return callOptions;
  }

  /**
   * Stop encrypted communication
   *
   * LWM2M path: /1024//46
   *
   * @tapVersion(">=1.11")
   * @return
   */
  stop(): Promise<TapResponse<Uint8Array>> {
    return this.serviceCallRunner.execute(this.stopCall());
  }

  /**
   *
   *
   * LWM2M path: /1024//46
   *
   * @tapVersion(">=1.11")
   * @return call options
   */
  stopCall(): ServiceCallType {
    const callOptions = { ...this.resources.stop };

    return callOptions;
  }

  /**
   * Communication channel
   *
   * LWM2M path: /1024//48
   *
   * @tapVersion(">=1.11")
   * @param data input
   * @return
   */
  send(
    /*
     *
     */
    data: Uint8Array,
  ): Promise<TapResponse<Uint8Array>> {
    return this.serviceCallRunner.execute(this.sendCall(data));
  }

  /**
   *
   *
   * LWM2M path: /1024//48
   *
   * @tapVersion(">=1.11")
   * @param data input
   * @return call options
   */
  sendCall(
    /*
     *
     */
    data: Uint8Array,
  ): ServiceCallType {
    const callOptions = { ...this.resources.send };

    callOptions.body = data;

    return callOptions;
  }

  /**
   * Exchange new Initialization Vectors
   *
   * LWM2M path: /1024//45
   *
   * @tapVersion(">=1.85")
   * @param data input
   * @return
   */
  setInitializationVector(
    /*
     * 16 bytes initialization vector
     */
    data: Uint8Array,
  ): Promise<TapResponse<Uint8Array>> {
    return this.serviceCallRunner.execute(
      this.setInitializationVectorCall(data),
    );
  }

  /**
   *
   *
   * LWM2M path: /1024//45
   *
   * @tapVersion(">=1.85")
   * @param data input
   * @return call options
   */
  setInitializationVectorCall(
    /*
     * 16 bytes initialization vector
     */
    data: Uint8Array,
  ): ServiceCallType {
    const callOptions = { ...this.resources.setInitializationVector };

    callOptions.body = data;

    return callOptions;
  }

  /**
   * Communication channel with encryption initialization vectory
   *
   * LWM2M path: /1024//44
   *
   * @tapVersion(">=1.85")
   * @param data input
   * @return
   */
  sendWithIV(
    /*
     *
     */
    data: EncryptedIVRequest,
  ): Promise<TapResponse<EncryptedIVResponse>> {
    return this.serviceCallRunner.execute(this.sendWithIVCall(data));
  }

  /**
   *
   *
   * LWM2M path: /1024//44
   *
   * @tapVersion(">=1.85")
   * @param data input
   * @return call options
   */
  sendWithIVCall(
    /*
     *
     */
    data: EncryptedIVRequest,
  ): ServiceCallType {
    const callOptions = { ...this.resources.sendWithIV };

    callOptions.body = data;

    return callOptions;
  }
}
